/*
  Hardcoded FAQ content for google gateways.
  This will only be displayed to users in India when this experiment is active
  https://tools.coursera.org/epic/experiment/qUohUPunEeuptMG5qj0t0g
*/
import { GOOGLE_GATEWAYS_FOR_OVERRIDES_SLUGS } from 'bundles/unified-description-page-common/constants';
import googleDataAnalyticsFaqs from 'bundles/unified-description-page-common/data/google-gateways-india-localization/faq-data/google-data-analytics';
import googleItAutomationFaqs from 'bundles/unified-description-page-common/data/google-gateways-india-localization/faq-data/google-it-automation';
import googleItSupportFaqs from 'bundles/unified-description-page-common/data/google-gateways-india-localization/faq-data/google-it-support';
import googleProjectManagementFaqs from 'bundles/unified-description-page-common/data/google-gateways-india-localization/faq-data/google-project-management';
import googleUxDesignFaqs from 'bundles/unified-description-page-common/data/google-gateways-india-localization/faq-data/google-ux-design';
import type { FaqFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';

type CmlFAQOverrides = {
  [slug: string]: (arg0: number) => Array<FaqFragment>;
};

export const faqOverrides: CmlFAQOverrides = {
  [GOOGLE_GATEWAYS_FOR_OVERRIDES_SLUGS.GOOGLE_IT_SUPPORT]: (productPrice: number) => {
    return googleItSupportFaqs(productPrice);
  },
  [GOOGLE_GATEWAYS_FOR_OVERRIDES_SLUGS.GOOGLE_DATA_ANALYTICS]: (productPrice: number) => {
    return googleDataAnalyticsFaqs(productPrice);
  },
  [GOOGLE_GATEWAYS_FOR_OVERRIDES_SLUGS.GOOGLE_PROJECT_MANAGEMENT]: (productPrice: number) => {
    return googleProjectManagementFaqs(productPrice);
  },
  [GOOGLE_GATEWAYS_FOR_OVERRIDES_SLUGS.GOOGLE_UX_DESIGN]: (productPrice: number) => {
    return googleUxDesignFaqs(productPrice);
  },
  [GOOGLE_GATEWAYS_FOR_OVERRIDES_SLUGS.GOOGLE_IT_AUTOMATION]: (productPrice: number) => {
    return googleItAutomationFaqs(productPrice);
  },
};

export default faqOverrides;
